// This polyfill changes the logic of <a></a> tag. If <a></a>'s href attribute contains app's origin we want to use router for navigation so app won't reload or open in webview.
import {router} from '@/integrations/router'

document.addEventListener('click', e => {
  let target = e.target
  
  // Recursive check to find whether click was fired inside an <a></a> tag
  while (target && target.tagName !== 'A') {
    target = target.parentElement
    
    if (target === null) {
      break
    }
  }
  
  if (
    target &&
    target.tagName === 'A' &&
    target.attributes &&
    target.attributes.href &&
    notContactLink(target.attributes.href.value) &&
    (hasSameDomain(target.attributes.href.value) || !hasDomain(target.attributes.href.value))
  ) {
    // Make sure that the link being clicked is outside of quill instance
    const quill = document.querySelector('.ql-editor')
    if (quill && quill.contains(target)) return

    e.preventDefault()

    let path = target.attributes.href.value
    if (hasDomain(target.attributes.href.value)) {
      const link = target.attributes.href.value.replace('http://', '').replace('https://', '')
      path = `/${link.split('/').slice(1).join('/')}`
    }
    router.push(path).catch((error) => {
      if (error.name !== 'NavigationDuplicated') throw error
    })
  }
})

// Check if <a></a>'s href attribute has the same origin as current app
function hasSameDomain(link) {
  const currentDomain = window.location.hostname

  const linkDomain =
    link.match(/^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:/\n?]+).*$/) &&
    link.match(/^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:/\n?]+).*$/)[1]

  return currentDomain === linkDomain
}

// If url has no domain (e.g. '/settings/48' not 'www.domain.com/settings/48') in it we always want to use router
function hasDomain(link) {
  const domainPattern = /^((https?|ftp):\/\/)?[^\s/$.?#].[^\s]*$/i
  return domainPattern.test(link)
}

// Make sure that link is not 'mailto:' or 'tel:'
function notContactLink(link) {
  return !(link.startsWith('mailto:') || link.startsWith('tel:'))
}
